import { Columns, LegacyCard, Stack, Text } from "@shopify/polaris";
import { Field } from "react-final-form";
import StockLevelField from "../StockLevelField.js";
import ActionField from "../ActionField.js";
import NotifySection from "../NotifySection/NotifySection.js";
import {
  PRODUCTS_ACTION_PUSH_DOWN_VISIBLE,
  PRODUCTS_ACTION_VISIBLE,
  PRODUCTS_NO_ACTION
} from "../../../../../../../../../constants/productActionTypes.js";

const actionOptions = [
  { label: "Make product visible", value: PRODUCTS_ACTION_VISIBLE },
  { label: "Push back up product", value: PRODUCTS_ACTION_PUSH_DOWN_VISIBLE },
  { label: "No action", value: PRODUCTS_NO_ACTION }
];

const BackStockCard = () => {
  return (
    <LegacyCard>
      <LegacyCard.Section>
        <Columns columns={{ xs: "1fr 1fr" }}>
          <Stack distribution={"fill"} vertical>
            <Field name="backStockLevel" component={StockLevelField} prefix="More than" label="Stock level" />
            <Field name="backStockAction" component={ActionField} options={actionOptions} />
            <Field name="backStockNotify" component={NotifySection} />
          </Stack>
        </Columns>
      </LegacyCard.Section>
    </LegacyCard>
  );
};

export default BackStockCard;